export default "__VITE_ASSET__BJO8CH2J__"